import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Bell } from "lucide-react";

export default function NotificationBell() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [unread, setUnread] = useState(0);
  const timer = useRef(null);

  useEffect(() => {
    if (!user || user === false) {
      setUnread(0);
      if (timer.current) clearInterval(timer.current);
      return;
    }
    const load = async () => {
      try {
        const { data } = await api.get("/notifications/unread-count");
        setUnread(data.unread || 0);
      } catch (e) { /* ignore */ }
    };
    load();
    timer.current = setInterval(load, 60000);
    return () => { if (timer.current) clearInterval(timer.current); };
  }, [user]);

  if (!user || user === false) return null;

  return (
    <button
      onClick={() => nav("/notifications")}
      className="relative p-2 rounded-md bg-white/5 hover:bg-white/10 border border-white/10"
      data-testid="notification-bell"
      aria-label="Notifications"
    >
      <Bell className="w-5 h-5 text-zinc-200" />
      {unread > 0 && (
        <span
          className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-600 text-white text-[10px] font-bold inline-flex items-center justify-center shadow-[0_0_8px_rgba(225,29,72,0.7)]"
          data-testid="notification-unread-count"
        >
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </button>
  );
}
